module.exports = "<p>\r\n  STEP-2\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-two/opst-step-two.component.html
// module id = ../../../../../src/app/content-page/admin/create-operating-standard/opst-step-two/opst-step-two.component.html
// module chunks = main